/**
 * --------------------------------------------------
 * !!! THIS FILE WAS GENERATED BY GRAPHQL-CODEGEN !!!
 * !!!   DO NOT MODIFY THIS FILE BY YOURSELF      !!!
 * --------------------------------------------------
 */

import * as c from "@hex/common";
import type * as Types from "../../../../generated/graphqlTypes";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type CalcPreviewQueryVariables = Types.Exact<{
  expr: Types.Scalars["String"]["input"];
  appSessionCellId: Types.Scalars["AppSessionCellId"]["input"];
  paramValues:
    | ReadonlyArray<Types.CalcPreviewParameterValue>
    | Types.CalcPreviewParameterValue;
}>;

export type CalcPreviewQuery = {
  readonly __typename: "Query";
  readonly calcPreview: {
    readonly __typename: "CalcPreviewResult";
    readonly previewData: ReadonlyArray<string>;
    readonly resultType: Types.DisplayTableColumnType;
  };
};

export const CalcPreviewDocument = /*#__PURE__*/ gql`
  query CalcPreview(
    $expr: String!
    $appSessionCellId: AppSessionCellId!
    $paramValues: [CalcPreviewParameterValue!]!
  ) {
    calcPreview(
      expr: $expr
      appSessionCellId: $appSessionCellId
      paramValues: $paramValues
    ) {
      previewData
      resultType
    }
  }
`;

/**
 * __useCalcPreviewQuery__
 *
 * To run a query within a React component, call `useCalcPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalcPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalcPreviewQuery({
 *   variables: {
 *      expr: // value for 'expr'
 *      appSessionCellId: // value for 'appSessionCellId'
 *      paramValues: // value for 'paramValues'
 *   },
 * });
 */
export function useCalcPreviewQuery(
  baseOptions: Apollo.QueryHookOptions<
    CalcPreviewQuery,
    CalcPreviewQueryVariables
  > &
    (
      | { variables: CalcPreviewQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CalcPreviewQuery, CalcPreviewQueryVariables>(
    CalcPreviewDocument,
    options,
  );
}
export function useCalcPreviewLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CalcPreviewQuery,
    CalcPreviewQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<CalcPreviewQuery, CalcPreviewQueryVariables>(
    CalcPreviewDocument,
    options,
  );
}
export function useCalcPreviewSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    CalcPreviewQuery,
    CalcPreviewQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<CalcPreviewQuery, CalcPreviewQueryVariables>(
    CalcPreviewDocument,
    options,
  );
}
export type CalcPreviewQueryHookResult = ReturnType<typeof useCalcPreviewQuery>;
export type CalcPreviewLazyQueryHookResult = ReturnType<
  typeof useCalcPreviewLazyQuery
>;
export type CalcPreviewSuspenseQueryHookResult = ReturnType<
  typeof useCalcPreviewSuspenseQuery
>;
export type CalcPreviewQueryResult = Apollo.QueryResult<
  CalcPreviewQuery,
  CalcPreviewQueryVariables
>;
